module.exports = __webpack_public_path__ + "static/media/email.1ac5e40a.png";